export default __webpack_public_path__ + "static/media/ljusa-tider-logo.69b89e6d.svg";